export default __webpack_public_path__ + "static/media/img-slider-om-platform-2.ee38b7d1.png";